import type { EditControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Checkbox, Switch } from 'antd'
import { ListTableContext } from 'src/components'
import { appStore } from 'src/stores'

const CheckboxControl = (props: EditControlProps) => {
  const table = useContext(ListTableContext)

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const find = table.tableConfig?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const handleGroupChange = (checkedValue: any[]) => {
    props.onChange?.(checkedValue.join(','))
  }

  const handleSwitchChange = (checked: boolean) => {
    props.onChange?.(checked)
  }

  const { __READONLY__, ENUM } = props.config

  if (ENUM) {
    return (
      <Checkbox.Group
        disabled={__READONLY__}
        value={props.value.split(',')}
        options={options}
        onChange={handleGroupChange}
      />
    )
  }

  return (
    <Switch
      disabled={__READONLY__}
      checked={props.value}
      onChange={handleSwitchChange}
    />
  )
}

export default CheckboxControl
